import { useGameContext } from '@/state/GameContext';

export function HistoryPanel() {
  const game = useGameContext();
  const items = game.history;
  return (
    <div className="panel-body">
      <div className="muted" style={{ marginBottom: 8 }}>{items.length} entries</div>
      {items.length === 0 ? <div className="muted">No crafting history yet.</div> : null}
      {items.slice(0, 200).map((h) => (
        <div key={h.id} className="list-item" style={{ cursor: 'default' }}>
          <div style={{ fontSize: 16 }}>{h.isVanilla ? '\u2714' : h.resultId ? '\u2728' : '\u2716'}</div>
          <div style={{ flex: 1 }}>
            <div className="li-name" style={{ color: h.resultId ? '#fff' : 'var(--danger)' }}>{h.label}</div>
            <div className="li-sub">{new Date(h.at).toLocaleTimeString()} &middot; {h.key.slice(0, 24)}{h.key.length > 24 ? '\u2026' : ''}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
